<div class="variable-parser-input">
  <input
    #inputRef
    cdkOverlayOrigin
    #variableOrigin="cdkOverlayOrigin"
    [type]="inputType"
    [class]="inputClass"
    [placeholder]="placeholder"
    [readonly]="readonly"
    [disabled]="disabled"
    [value]="value"
    (input)="onInput($event)"
    (keydown)="onKeyDown($event)"
    (focus)="handleSuggestions(inputRef)"
    (blur)="onBlur()"
  />

  <app-floating-dropdown
    [origin]="variableOrigin"
    [open]="showSuggestions"
    [matchTriggerWidth]="true"
    panelClass="p-0"
    minWidth="12rem"
    maxHeight="14rem"
    (openChange)="onSuggestionsOpenChange($event)"
  >
    <button
      type="button"
      class="variable-suggestion-item"
      *ngFor="let s of filtered"
      (mousedown)="onSuggestionMouseDown($event)"
      (click)="select(s)"
    >
      <span>{{ s.label || s.key }}</span>
      <span class="variable-suggestion-scope">{{ s.scope }}</span>
    </button>
  </app-floating-dropdown>
</div>
